import React from "react";
import Button from "components/common/ui/buttons/Button/Button";
import styled from "styled-components";
import FeatureRequestsModal from "./FeatureRequestsModal";
import FeatureRequestsDropdown from "./FeatureRequestsDropdown";
import FeatureRequestInput from "./FeatureRequestInput";

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const Header = styled.h4`
    margin: 0;
    font-weight: 600;
`;

const FilterContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
    width: 100%;
    gap: 1rem;

    & > * {
        flex-basis: 50%;
    }
`;

interface FeatureRequestsControlsProps {
    getFilterValue: (filterName: string) => string;
    setFilterValue: (filterName: string, value: string) => void;
}

const stateOptions = [
    { value: "", label: "Kaikki" },
    { value: "Uusi", label: "Uusi" },
    { value: "Käsittelyssä", label: "Käsittelyssä" },
    { value: "Ratkaistu", label: "Ratkaistu" },
    { value: "Hylätty", label: "Hylätty" },
];

const FeatureRequestsControls: React.FC<FeatureRequestsControlsProps> = ({
    getFilterValue,
    setFilterValue,
}) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isStateDropdownOpen, setIsStateDropdownOpen] = React.useState(false);

    return (
        <div>
            <HeaderContainer>
                <Header>Tarkastele kehitysehdotuksia</Header>
                <Button onClick={() => setIsModalOpen(true)}>+ Uusi kehitysehdotus</Button>
            </HeaderContainer>
            <FilterContainer>
                <FeatureRequestInput
                    label="Haku"
                    placeholder="Hae ID:llä, otsikolla tai kuvauksella"
                    value={getFilterValue("search")}
                    onChange={(value) => setFilterValue("search", value)}
                />
                <FeatureRequestsDropdown
                    label="Tila"
                    isOpen={isStateDropdownOpen}
                    toggle={setIsStateDropdownOpen}
                    options={stateOptions}
                    selectedValue={getFilterValue("state")}
                    onValueChange={(value) => setFilterValue("state", value)}
                    placeholder="Kaikki tilat"
                    fullWidth={true}
                />
            </FilterContainer>
            <FeatureRequestsModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
            />
        </div>
    );
};

export default FeatureRequestsControls;
